import React from 'react';
import { AlertCircle, CheckCircle } from 'react-feather';
import "./AlertBanner.scss";

// Alert banner will only display if #master-grid has "grid-alert-banner-active" class attached.

const AlertBanner = (props) => {
	const { icon, hideIcon, message, children, type, fullWidth } = props;
	return (
		<div className={`alert-banner-wrapper${type ? " alert-type-" + type : ""}`} style={{width: fullWidth ? "100%" : null}}>
			{/* Icon */}
			{hideIcon ? "" : <div class="alert-banner-icon">{icon ? icon : type === "positive" ? <CheckCircle /> : type === "warning" || type === "danger" ? <AlertCircle /> : ""}</div>}
			{/* Message */}
			<div class="alert-banner-message">{message || children}</div>
		</div>
	)
}

export default AlertBanner;